import { useState } from "react";
import type { FormEvent } from "react";
import { Link } from "react-router-dom";

export function ResetPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSent(true);
  }

  return (
    <div className="ns-login-bg">
      <div className="ns-login-card">
        <div className="ns-login-logo">🔑</div>
        <h1 className="ns-login-title-sm">Reset Password</h1>
        <p className="ns-login-subtitle-sm">We'll send you a reset link</p>
        {sent ? (
          <div className="ns-alert-success">
            <i className="bi bi-envelope-check ns-alert-success-icon"></i>
            <div className="ns-alert-success-title">Email sent!</div>
            <div className="ns-alert-success-msg">Check your inbox for reset instructions.</div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="ns-form-col">
            <div>
              <label className="ns-label">Email Address</label>
              <input className="ns-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" required />
            </div>
            <button type="submit" className="btn-theme ns-btn-full-md">
              <i className="bi bi-send"></i> Send Reset Link
            </button>
          </form>
        )}
        <div className="ns-login-back">
          <Link to="/admin/login"><i className="bi bi-arrow-left"></i> Back to login</Link>
        </div>
      </div>
    </div>
  );
}
